import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lightning } from 'phosphor-react';

const SkillPractice = ({ skillId, onSkillPracticeStart, variant }) => {
  const navigate = useNavigate();

  const handleStart = () => {
    if (onSkillPracticeStart) {
      onSkillPracticeStart({ skillId });
    } else if (skillId) {
      navigate('/quick-practice', {
        state: {
          skillId,
          fromPage: '/learner/language-learning'
        }
      });
    }
  };

  const isHeader = variant === 'header';
  const isFixed = variant === 'fixed';
  const isBelowHeader = variant === 'below-header';

  if (isHeader) {
    return (
      <div
        className="bg-gradient-to-br from-[#fcb319] to-[#f5a500] border border-[rgba(252,179,25,0.9)] rounded-[10px] p-[4px_10px] shadow-[0_2px_6px_rgba(252,179,25,0.25)] inline-flex items-center justify-center gap-2 cursor-pointer transition-all duration-200 relative"
        onClick={handleStart}
      >
        <div className="flex items-center gap-[6px]">
          <Lightning size={16} className="text-[#1d4746]" />
          <span className="text-[12px] font-semibold text-[#1d4746]">Skill Practice</span>
        </div>
      </div>
    );
  }

  if (isBelowHeader) {
    return (
      <div
        className="w-full flex items-center justify-between p-[10px_16px] rounded-[10px] cursor-pointer bg-[rgba(245,245,245,0.98)] dark:bg-[var(--bg-tertiary)] border border-[rgba(0,0,0,0.08)] dark:border-[rgba(255,255,255,0.1)] transition-all duration-200"
        onClick={handleStart}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleStart(); } }}
      >
        <div className="flex items-center gap-2">
          <Lightning size={16} className="text-[#1d4746] dark:text-[var(--text-primary)]" />
          <span className="text-[14px] font-semibold text-[#1d4746] dark:text-[var(--text-primary)]">Skill Practice</span>
        </div>
        <button
          type="button"
          className="p-[6px_12px] bg-gradient-to-br from-[#fcb319] to-[#f5a500] !text-[#1d4746] border-none rounded-[8px] text-[11px] font-semibold cursor-pointer transition-all duration-300 shadow-[0_2px_4px_rgba(252,179,25,0.2)] relative overflow-hidden whitespace-nowrap hover:from-[#f5a500] hover:to-[#e69500] hover:shadow-[0_4px_8px_rgba(252,179,25,0.3)] hover:-translate-y-px active:translate-y-0 active:scale-[0.98]"
          onClick={(e) => { e.stopPropagation(); handleStart(); }}
          aria-label="Start practice"
        >
          Start
        </button>
      </div>
    );
  }

  // base + fixed variant
  return (
    <div
      className={`bg-[rgba(255,255,255,0.95)] dark:bg-[var(--bg-secondary)] border-2 border-[rgba(18,118,109,0.25)] dark:border-[rgba(20,184,166,0.3)] rounded-xl shadow-[0_2px_12px_rgba(0,0,0,0.1)] dark:shadow-[0_2px_12px_rgba(0,0,0,0.4)] inline-flex items-center justify-center gap-2 cursor-pointer transition-all duration-200 relative hover:-translate-y-0.5 hover:shadow-[0_4px_16px_rgba(0,0,0,0.15)] hover:border-[rgba(18,118,109,0.4)] dark:hover:border-[rgba(20,184,166,0.5)] dark:hover:shadow-[0_4px_16px_rgba(0,0,0,0.5)] ${isFixed ? 'p-[10px_18px]' : 'p-[8px_12px]'}`}
      onClick={handleStart}
    >
      <div className="flex items-center gap-[6px]">
        <Lightning size={16} className="text-[#12766d] dark:text-[var(--accent-teal)]" />
        <span className="text-[12px] font-semibold text-[#12766d] dark:text-[var(--accent-teal)]">Skill Practice</span>
      </div>
    </div>
  );
};

export default SkillPractice;
